<template>
  <GmapMap
    v-if="mapProvider === MapProvider.GOOGLE"
    style="height: 100%"
    :zoom="12"
    :center="location"
    :options="{
      zoomControl: true,
      mapTypeControl: true,
      scaleControl: false,
      streetViewControl: false,
      rotateControl: false,
      fullscreenControl: true,
      disableDefaultUi: false,
      gestureHandling: 'greedy'
    }"
  >
    <GmapMarker
      v-for="(locationItem, index) in locations"
      :key='`location-${index}`'
      :position="locationItem"
      :title="
        (locationItem.label ?? `Ubicación ${index}`) + '\n' +
        getLocationDistanceText(locationItem, location)
      "
      :icon="getPublicImgPath('img/maps/icon-0.png')"
    />
    <GmapMarker
      v-if="isRefLocationVisible"
      :position="refLocation"
      :title="
        'GPS de referencia' + (refLocation.label ? ` [${refLocation.label}]` : '') + '\n' +
        getLocationDistanceText(refLocation, location)
      "
      :icon="getPublicImgPath('img/maps/icon-0.png')"
    />
    <!-- We render this marker at last to ensure that this will always be render at the top of the other positions -->
    <GmapMarker
      :position="location"
      :icon="getPublicImgPath('img/maps/icon-1.png')"
      :title="location.label"
    />
  </GmapMap>
  <LocationMapMapbox
    v-else
    :location="location"
    :locations="locations"
    :refLocation="refLocation"
    :isRefLocationVisible="isRefLocationVisible"
  />
</template>

<script lang="ts">
import { Component, Vue, Prop } from 'vue-property-decorator'
import LocationMapMapbox from './LocationMapMapbox.vue'
import { MarkerPosition } from '@/types//Maps'
import userInfoStore from '@/store/userInfo'
import { MapProvider } from '@/types//Auth'
import config from '@/config'

@Component({
  components: {
    LocationMapMapbox
  }
})
export default class LocationMap extends Vue {
  @Prop({ required: true })
  location: MarkerPosition

  /** Optional prop to display more than one location */
  @Prop({ required: false })
  locations: MarkerPosition[]

  @Prop({ required: false })
  refLocation: MarkerPosition

  mapProvider: MapProvider = userInfoStore.userInfo.domain.mapProvider
  MapProvider = MapProvider

  get isRefLocationVisible () {
    return this.refLocation && (this.location.lat.toString() + this.location.lng.toString()) !== (this.refLocation.lat.toString() + this.refLocation.lng.toString())
  }

  getPublicImgPath (path: string) {
    return config.basePath + path
  }

  getLocationDistanceText (locationA: MarkerPosition, locationB: MarkerPosition) {
    return `Distancia: ${locationA.haversineDistance(locationB).toFixed(2)} KM`
  }
}
</script>

<style lang="scss">
.google-map {
  height: 100%;
}
</style>
